import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, StackView } from 'localmed-core';
import React from 'react';
import { CaptionText } from '../pages/SchedulingPage/components/styles';
import { Theme } from '../../diTheme';
import { Link } from '../../shared/components/DiComponents';
import { IWizardController } from '../pages/SchedulingPage/components/schedulingWizard';

interface SelectedReasonForVisitProps {
  wizard: IWizardController;
}

const Container = styled('div')<{}, Theme>(
  ({ theme }) => css`
    padding-bottom: ${theme.space.md};
    border-bottom: 2px solid ${theme.colors.grays[200]};
  `
);

const Description = styled(CaptionText)<{}, Theme>(
  ({ theme }) => css`
    margin-top: ${theme.space.xs};
    font-size: ${theme.fontSizes.xs};
  `
);

export default function SelectedReasonForVisit({ wizard }: SelectedReasonForVisitProps) {
  const { reasonForVisit } = wizard.values;
  if (reasonForVisit == null) {
    return null;
  }
  return (
    <Container>
      <StackView direction="row" spacing="lg" justifyContent={{ _: 'center', lg: 'flex-start' }}>
        <Box>{reasonForVisit.name}</Box>
        <Link
          onClick={() => {
            wizard.gotoStep(1);
          }}
          fontWeight="bold"
        >
          <FontAwesomeIcon icon={faPen} /> Change
        </Link>
      </StackView>
      {reasonForVisit.description && <Description>{reasonForVisit.description}</Description>}
    </Container>
  );
}
